import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTotalsByFilterLicencia } from "../../../redux/actions";

function FilterLicenciasComponent({ fetchLicencias }) {
  const dispatch = useDispatch();

  const [currentFilter, setCurrentFilter] = useState("todas");

  const limit = useSelector(
    (state) => state.limitLicencias
  );

  const totalsByFilter = useSelector(
    (state) => state.totalsByFilterLicencia
  );

  const FILTERS = {
    todas: {
      label: "Todas",
      message: "",
    },
    ingresadas: {
      label: "Ingresadas",
      message:
        "Licencias que se encuentran actualmente en el corralón",
    },
    egresadas: {
      label: "Egresadas",
      message: "Licencias que ya se entregaron",
    },
  };

  useEffect(() => {
    dispatch(getTotalsByFilterLicencia());
  }, [dispatch]);

  const buttonStyles = (type) =>
    currentFilter === type
      ? "bg-[#0a5477] text-white"
      : "bg-[#d7eaff] text-[#0477ad]";

  const setFilter = async (type) => {
    setCurrentFilter(type);

    await fetchLicencias(
      1,
      type,
      limit
    );
  };

  return (
    <div>
      <div className="flex gap-2 justify-center sm:justify-start items-center p-4">
        {Object.entries(FILTERS).map(([key, config]) => (
          <button
            key={key}
            onClick={() => setFilter(key)}
            className={`px-3 py-1 rounded-sm inline-flex justify-center items-center ${buttonStyles(
              key
            )}`}
          >
            <div className="font-semibold font-inter sm:text-[1rem] text-[0.7rem] whitespace-nowrap">
              {config.label ?? key}
            </div>

            <div className="ml-1 text-[0.8rem] sm:text-[0.95rem] font-bold px-2 py-[2px] rounded-sm">
              ({totalsByFilter[key] ?? 0})
            </div>
          </button>
        ))}
      </div>

      <div className="text-[#687073] sm:text-[1.1rem] text-s font-medium font-inter justify-center text-center px-4">
        {FILTERS[currentFilter]?.message ?? ""}
      </div>
    </div>
  );
}

export default FilterLicenciasComponent;